import type {SketchLineObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchLineMultiRelationConstraint} from './SketchLineMultiRelationConstraint';

let count = 0;

/**
 * 判断对象是否为共线关系。
 * @param value 待判断对象。
 * @returns 是否为共线关系。
 */
export function isLineCollinearConstraint(value: object): value is LineCollinearConstraint {
    return Reflect.get(value, 'isLineCollinearConstraint') === true;
}

/**
 * 两直线共线关系定义。
 *
 * 参数系统直接约束无限直线方向与点在线条件，不保存对象式锁定锚线。
 */
export class LineCollinearConstraint extends SketchLineMultiRelationConstraint<SketchLineObject> {
    /** 运行时类型标记。 */
    public readonly isLineCollinearConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Collinear;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '共线';
    }
}
